(function (angular) {
  var m = angular.module("pcmwsui.message", []);

  m.directive("pcmwsuiMessage", ["$location", function ($location) {

    var templateString =
      //"<div id=\"pcmwsuiMessage\" style=\"display:{{ showPcmwsuiMessage ? 'block' : 'none' }};\">" + // doesn't work in IE10
      "<div id=\"pcmwsuiMessage\" ng-attr-style=\"{{pcmwsuiStyleVar}}\">" +
      "<div class=\"alert alert-danger\" style=\"background-color:#fcf8e3;\">" +
      "<a class=\"close\" ng-click=\"closeMessage()\">&times;</a>" +
      "<span style=\"font-weight:bold;\">You have been re-directed to PC*Miler Web because the PC*Miler Web Services User Interface has been shut off. If you would like to maintain a visual interface to PC*Miler, contact your account representative at 800-377-6453 ext. 1 or <a href=\"mailto:sales@alk.com\">sales@alk.com</a>.</span>" +
      "</div>" +
      "</div>";

    return {
      restrict: "E",
      replace: true,
      scope: {},

      controller: ["$scope", function ($scope) {
        $scope.showPcmwsuiMessage = false;
        if ($location.search().pcmwsui)
          $scope.showPcmwsuiMessage = true;

        $scope.closeMessage = function () {
          $scope.showPcmwsuiMessage = false;
          $scope.pcmwsuiStyleVar = "display: none;";
        };

        $scope.pcmwsuiStyleVar = $scope.showPcmwsuiMessage ? "display: block;" : "display: none;";

      }],

      template: templateString
    }

  }]);

})(angular);



// WEBPACK FOOTER //
// ./app/components/pcmwsuiMessage.directive.js